/* ============================================
   BLEND PARC — Theme JavaScript
   ============================================ */

document.addEventListener('DOMContentLoaded', () => {

  /* ============ SEARCH OVERLAY ============ */
  const searchBtn = document.getElementById('search-btn');
  const searchOverlay = document.getElementById('search-overlay');
  const searchClose = document.getElementById('search-close');
  const searchInput = document.getElementById('search-input');

  if (searchBtn && searchOverlay) {
    searchBtn.addEventListener('click', (e) => {
      e.preventDefault();
      searchOverlay.classList.add('is-open');
      if (searchInput) {
        searchInput.value = '';
        setTimeout(() => searchInput.focus(), 100);
      }
      // Fetch products for search via Shopify AJAX
      fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=20')
        .then(r => r.json())
        .then(data => {
          const products = data.resources?.results?.products || [];
          renderSearchResults(products);
        })
        .catch(() => {});
    });

    if (searchClose) {
      searchClose.addEventListener('click', () => {
        searchOverlay.classList.remove('is-open');
      });
    }

    if (searchInput) {
      let debounceTimer;
      searchInput.addEventListener('input', () => {
        clearTimeout(debounceTimer);
        const q = searchInput.value.trim();
        debounceTimer = setTimeout(() => {
          if (!q) {
            fetch('/search/suggest.json?q=*&resources[type]=product&resources[limit]=20')
              .then(r => r.json())
              .then(data => renderSearchResults(data.resources?.results?.products || []))
              .catch(() => {});
            return;
          }
          fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=20`)
            .then(r => r.json())
            .then(data => renderSearchResults(data.resources?.results?.products || []))
            .catch(() => {});
        }, 200);
      });
    }
  }

  function renderSearchResults(products) {
    const grid = document.getElementById('search-results');
    const count = document.getElementById('search-count');
    if (!grid) return;

    if (products.length === 0) {
      grid.innerHTML = '<div class="search-results__empty">NO RESULTS FOUND</div>';
      if (count) count.textContent = '0 RESULTS';
      return;
    }
    if (count) count.textContent = products.length + ' RESULT' + (products.length !== 1 ? 'S' : '');
    grid.innerHTML = products.map(p => `
      <a href="${p.url}" class="search-result">
        <div class="search-result__media">
          ${p.image ? `<img src="${p.image}" alt="${p.title}" style="width:100%;height:100%;object-fit:cover;">` : ''}
        </div>
        <div class="search-result__info">
          <div class="search-result__name">${p.title.toUpperCase()}</div>
          <div class="search-result__price">${p.price}</div>
        </div>
      </a>
    `).join('');
  }

  /* ============ CART DRAWER ============ */
  const cartBtn = document.getElementById('cart-btn');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartClose = document.getElementById('cart-close');
  const cartShopBtn = document.getElementById('cart-shop-btn');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
  }

  if (cartBtn) {
    cartBtn.addEventListener('click', (e) => {
      e.preventDefault();
      openCart();
      refreshCart();
    });
  }
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
  if (cartShopBtn) cartShopBtn.addEventListener('click', closeCart);

  function refreshCart() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const body = document.getElementById('cart-drawer-body');
        const footer = document.getElementById('cart-drawer-footer');
        const subtotal = document.getElementById('cart-drawer-subtotal');

        if (cart.item_count === 0) {
          if (body) body.innerHTML = `
            <div class="cart-drawer__empty">
              <p class="cart-drawer__empty-text">YOUR CART IS EMPTY</p>
              <button class="cart-drawer__empty-cta" onclick="document.getElementById('cart-drawer').classList.remove('is-open');document.getElementById('cart-overlay').classList.remove('is-open');">CONTINUE SHOPPING</button>
            </div>`;
          if (footer) footer.style.display = 'none';
        } else {
          if (body) {
            body.innerHTML = cart.items.map(item => `
              <div style="display:flex;gap:16px;padding:12px 0;border-bottom:1px solid #e2ddd6;">
                <div style="width:80px;height:80px;background:#f4f4f4;flex-shrink:0;overflow:hidden;">
                  ${item.image ? `<img src="${item.image}" style="width:100%;height:100%;object-fit:cover;">` : ''}
                </div>
                <div style="flex:1;">
                  <p style="font-family:var(--font-heading);font-size:12px;font-weight:600;letter-spacing:0.04em;text-transform:uppercase;margin-bottom:4px;">${item.title.toUpperCase()}</p>
                  <p style="font-size:11px;opacity:0.5;margin-bottom:4px;">${item.variant_title || ''}</p>
                  <p style="font-size:12px;">QTY: ${item.quantity} — ${(item.final_line_price / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD'})}</p>
                </div>
              </div>
            `).join('');
          }
          if (footer) footer.style.display = 'block';
          if (subtotal) subtotal.textContent = (cart.total_price / 100).toLocaleString('en-US', {style: 'currency', currency: 'USD'});
        }
      })
      .catch(() => {});
  }

  /* ============ ADD TO CART (PDP) ============ */
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const formData = new FormData(productForm);
      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
        .then(r => r.json())
        .then(() => {
          openCart();
          refreshCart();
        })
        .catch(() => {});
    });
  }

  /* ============ VARIANT SELECTOR ============ */
  document.querySelectorAll('.pdp__size').forEach(btn => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.pdp__sizes');
      parent.querySelectorAll('.pdp__size').forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
    });
  });

  /* ============ ACCORDION ============ */
  document.querySelectorAll('.pdp__accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.parentElement;
      item.classList.toggle('is-open');
    });
  });

  /* ============ MOBILE NAV ============ */
  const mobileMenuBtn = document.getElementById('mobile-menu-btn');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavOverlay = document.getElementById('mobile-nav-overlay');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  function openMobileNav() {
    if (mobileNav) mobileNav.classList.add('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.add('is-open');
  }
  function closeMobileNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    if (mobileNavOverlay) mobileNavOverlay.classList.remove('is-open');
  }

  if (mobileMenuBtn) mobileMenuBtn.addEventListener('click', openMobileNav);
  if (mobileNavClose) mobileNavClose.addEventListener('click', closeMobileNav);
  if (mobileNavOverlay) mobileNavOverlay.addEventListener('click', closeMobileNav);

  /* ============ ESCAPE KEY ============ */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      if (searchOverlay) searchOverlay.classList.remove('is-open');
      closeCart();
      closeMobileNav();
    }
  });

});
